import { gql } from '@apollo/client'

export const UPDATE_REQUESTED_INFO_TYPE_MUTATION = gql`
  mutation updateRequestedInfoType($id: ID!, $attributes: RequestedInfoTypeInput!) {
    updateRequestedInfoType(id: $id, attributes: $attributes) {
      id
      name
      kind
      description
    }
  }
`
